// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as DropZone from "../../resources/selection-and-input/DropZone.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as FilePicker from "../../primitives/FilePicker.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as PublicPage from "../../resources/layout-and-structure/PublicPage.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let fileTypes = ["zip"];
function errorMessageFromError(error) {
  if (error === "UnknownFailure") {
    return I18n.t("cash_register_archive_verify_page.request_error.something_wrong_happened_we_could_not_check_the_file");
  } else {
    return I18n.t("cash_register_archive_verify_page.request_error.invalid_file");
  }
}
let endpoint = Env.posGatewayUrl() + "/compliance/verify-cash-register-archive";
function decodeInvalidRequestFailure(error) {
  switch (error.kind) {
    case "InvalidCashRegisterArchiveFile":
      return "InvalidCashRegisterArchiveFile";
    case "JsonWebTokenError":
      return "JsonWebTokenError";
    case "SchemaValidation":
      return "SchemaValidation";
    case "UnexpectedCashRegisterArchiveFileType":
      return "UnexpectedCashRegisterArchiveFileType";
    case "UnexpectedMissingArchiveZipFile":
      return "UnexpectedMissingArchiveZipFile";
    case "UnexpectedMissingIntegrityFile":
      return "UnexpectedMissingIntegrityFile";
    default:
      return "UnknownFailure";
  }
}
function mapFutureResult(futureResult) {
  return Future.mapError(Future.mapOk(futureResult, undefined, Json.decodeDict), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return "UnknownFailure";
    } else {
      return Stdlib_Option.getOr(Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure), "UnknownFailure");
    }
  });
}
function make(fiscalArchiveFile) {
  return mapFutureResult(Request.make(endpoint, "POST", {
    TAG: "FileBody",
    _0: fiscalArchiveFile
  }, false, undefined));
}
let ComplianceVerifyCashRegisterArchiveFileRequest = {
  endpoint: endpoint,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  mapFutureResult: mapFutureResult,
  make: make
};
function ComplianceVerifyCashRegisterArchivePage$ComplianceVerifyCashRegisterArchiveFilePicker(props) {
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("cash_register_archive_verify_page.file_card.inline_text_1"),
        variation: "normal"
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("cash_register_archive_verify_page.file_card.inline_text_2"),
        variation: "normal"
      })],
      align: "center"
    }), JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(FilePicker.make, {
        children: JsxRuntime.jsx(Button.make, {
          label: I18n.t("Pick file")
        }),
        types: fileTypes,
        maxSizeMb: 50,
        onChange: props.onPickSuccess,
        onError: props.onPickError
      }),
      align: "center"
    })],
    space: "medium"
  });
}
let ComplianceVerifyCashRegisterArchiveFilePicker = {
  make: ComplianceVerifyCashRegisterArchivePage$ComplianceVerifyCashRegisterArchiveFilePicker
};
let styles = {
  Card_root: {
    "backgroundColor-kWkggS": "backgroundColor-x1srn7af",
    "borderColor-kVAM5u": "borderColor-x1fs2082",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "padding-kmVPX3": "padding-x10xs6qf",
    $$css: "wino-gc:src/app/Compliance/ComplianceVerifyCashRegisterArchivePage.res.js:120"
  }
};
function ComplianceVerifyCashRegisterArchivePage$ComplianceVerifyCashRegisterArchiveFileCard(props) {
  let onRejectFile = props.onRejectFile;
  let onAcceptFile = props.onAcceptFile;
  let newrecord = {
    ...{
      className: "backgroundColor-x1srn7af borderColor-x1fs2082 borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 justifyContent-xl56j7k padding-x10xs6qf",
      "data-style-src": "wino-gc:src/app/Compliance/ComplianceVerifyCashRegisterArchivePage.res.js:120"
    }
  };
  let tmp;
  let tmp$1 = props.fileImportAsyncResult;
  tmp = typeof tmp$1 !== "object" ? tmp$1 === "NotAsked" ? JsxRuntime.jsx(ComplianceVerifyCashRegisterArchivePage$ComplianceVerifyCashRegisterArchiveFilePicker, {
    onPickSuccess: onAcceptFile,
    onPickError: onRejectFile
  }) : JsxRuntime.jsx(Placeholder.make, {
    status: "Loading"
  }) : tmp$1.TAG === "Reloading" ? JsxRuntime.jsx(Placeholder.make, {
    status: "Loading"
  }) : null;
  newrecord.children = tmp;
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(DropZone.make, {
      children: JsxRuntime.jsx("div", newrecord),
      types: fileTypes,
      maxSizeMb: 50,
      onSuccess: onAcceptFile,
      onError: onRejectFile
    }),
    title: I18n.t("cash_register_archive_verify_page.file_card.title")
  });
}
let ComplianceVerifyCashRegisterArchiveFileCard = {
  styles: styles,
  make: ComplianceVerifyCashRegisterArchivePage$ComplianceVerifyCashRegisterArchiveFileCard
};
function ComplianceVerifyCashRegisterArchivePage(props) {
  let match = React.useState(() => AsyncResult.notAsked());
  let setFileImportAsyncResult = match[1];
  let match$1 = React.useState(() => {});
  let setNotification = match$1[1];
  let notification = match$1[0];
  let onAcceptFile = fiscalArchiveFile => {
    setFileImportAsyncResult(param => AsyncResult.loading());
    Future.tap(make(fiscalArchiveFile), result => {
      setFileImportAsyncResult(param => "NotAsked");
      if (result.TAG === "Ok") {
        return setNotification(param => ({
          TAG: "Ok",
          _0: I18n.t("cash_register_archive_verify_page.request_ok.valid_file")
        }));
      }
      let error = result._0;
      setNotification(param => ({
        TAG: "Error",
        _0: errorMessageFromError(error)
      }));
    });
  };
  let onRejectFile = fileImportErrorMessage => setNotification(param => ({
    TAG: "Error",
    _0: fileImportErrorMessage
  }));
  let onClearNotification = () => setNotification(param => {});
  let tmp;
  if (notification !== undefined) {
    let tmp$1;
    tmp$1 = notification.TAG === "Ok" ? {
      TAG: "Success",
      _0: notification._0
    } : {
      TAG: "Danger",
      _0: notification._0
    };
    tmp = JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: tmp$1,
        onRequestClose: onClearNotification
      }),
      spaceTop: "medium"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(PublicPage.make, {
    children: [tmp, JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Stack.make, {
        children: JsxRuntime.jsx(ComplianceVerifyCashRegisterArchivePage$ComplianceVerifyCashRegisterArchiveFileCard, {
          fileImportAsyncResult: match[0],
          onAcceptFile: onAcceptFile,
          onRejectFile: onRejectFile
        }),
        space: "medium"
      }),
      spaceTop: "large"
    })],
    title: I18n.t("cash_register_archive_verify_page.header.title"),
    description: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("cash_register_archive_verify_page.header.subtitle_1"),
        variation: "normal"
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("cash_register_archive_verify_page.header.subtitle_2"),
        variation: "normal"
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("cash_register_archive_verify_page.header.subtitle_3"),
        variation: "normal"
      }), JsxRuntime.jsx(TextAction.make, {
        text: I18n.t("cash_register_archive_verify_page.header.subtitle_link"),
        highlighted: true,
        onPress: () => HelpCenter.showArticle(HelpCenter.verifyCashRegisterArchive)
      })]
    })
  });
}
let make$1 = React.memo(ComplianceVerifyCashRegisterArchivePage);
let fileMaxSizeMb = 50;
export { fileTypes, fileMaxSizeMb, errorMessageFromError, ComplianceVerifyCashRegisterArchiveFileRequest, ComplianceVerifyCashRegisterArchiveFilePicker, ComplianceVerifyCashRegisterArchiveFileCard, make$1 as make };
/* endpoint Not a pure module */